import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M25.8 2.11004C30.29 4.22004 35.63 10.63 35.14 26.48C34.66 42.33 22.4 62.85 5.27002 58.56C5.27002 58.56 14.2 57.32 11.18 45.08C8.15999 32.84 3.83002 19.7401 8.21002 10.0401C12.61 0.330095 21.86 0.250042 25.8 2.11004Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M8.51001 58.6899C8.51001 58.6899 17.78 57.1799 17.98 46.6799C18.32 29.0899 15 10.13 24.37 3.25C24.37 3.25 25.08 6.69002 27.57 22.4C29.22 32.84 27.24 56.48 11.75 58.74"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M20.0201 3.33997C20.0201 3.33997 6.14008 7.07003 12.9601 35.16C16.5801 50.1 14.45 56.56 9.04004 58.05"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M65.8402 2.11004C61.3502 4.22004 56.0102 10.63 56.5002 26.48C56.9802 42.33 69.2401 62.85 86.3701 58.56C86.3701 58.56 77.4402 57.32 80.4602 45.08C83.4802 32.84 87.8101 19.7401 83.4301 10.0401C79.0401 0.330095 69.7902 0.250042 65.8402 2.11004Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M83.1302 58.6899C83.1302 58.6899 73.8602 57.1799 73.6602 46.6799C73.3202 29.0899 77.3402 10.22 67.9802 3.33997C67.9802 3.33997 66.5602 6.69002 64.0702 22.4C62.4202 32.84 64.4002 56.48 79.8902 58.74"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M71.6201 3.33997C71.6201 3.33997 85.5001 7.07003 78.6801 35.16C75.0601 50.1 77.1901 56.56 82.6001 58.05"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
